/**
 * Reference-counted body scroll lock.
 *
 * Multiple overlapping overlays (modals, sheets) can each call lock()/unlock()
 * independently. The body scroll is only restored once every caller has
 * unlocked — preventing one overlay's cleanup from re-enabling scroll while a
 * sibling overlay is still open.
 */

let lockCount = 0

export function lock(): void {
    lockCount++
    if (lockCount === 1) {
        document.body.style.overflow = 'hidden'
    }
}

export function unlock(): void {
    if (lockCount <= 0) return
    lockCount--
    if (lockCount === 0) {
        document.body.style.overflow = ''
    }
}
